<section class="scr-page scr-page--compact">
  <div class="scr-card payment-card">
    <tp-page-header
      class="tp-page-header--split" variant="toolbar"
      title="Pago a prestadores"
      [subtitle]="isProjection ? 'Proyección de pagos por prestador' : 'Pagos por prestador'"
    >
      <div class="scr-search">
        <mat-icon class="scr-search__icon" aria-hidden="true">search</mat-icon>
        <input type="text" class="form-control" placeholder="Buscar pagos" aria-label="Buscar pagos" [formControl]="searchTextControl" />
      </div>
      <!-- The date panel hangs from its own button, so it opens right under it. -->
      <div class="date-filter-anchor">
        <button
          mat-stroked-button
          type="button"
          class="filter-button"
          title="Abrir filtros"
          (click)="toggleVisibility()"
        >
          <mat-icon>filter_list</mat-icon>
          Fechas
        </button>
        <app-dates-filter [visibility]="isVisible"
        (sendDates)="setDates($event)" (clickOutside)="closeModal()"></app-dates-filter>
      </div>
    <mat-form-field actions appearance="outline" subscriptSizing="dynamic" class="type-select">
      <mat-select [(value)]="isProjection" (selectionChange)="changeProjection()" aria-label="Tipo de listado">
        <mat-option [value]="true">Proyecciones</mat-option>
        <mat-option [value]="false">Pagos</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-stroked-button actions type="button" (click)="exportAsPDF()" [disabled]="disablePrint">
      <mat-icon>print</mat-icon>
      Imprimir
    </button>
    </tp-page-header>
    <div class="table-container tp-table-responsive">
      <table id="dataToPrint" class="w-100" #contentToPrint [ngClass]="isProjection ? 'projection-style' : ''">
        <thead>
          <tr>
            <th class="contractor-header"></th>
            <th>Día</th>
            <th>Tipo de tarea</th>
            <th>Producto</th>
            <th>Ciudad</th>
            <th>Cliente</th>
            <th>Adicional</th>
            <th>Precio</th>
            <th>Importe</th>
            <th class="extras">Extras</th>
          </tr>
        </thead>
        <tbody>
          @for (
            entry of filteredEntriesArray
            | filterByPaymentPages : pages : seleccionado; track
            entry; let i = $index) {
            <!-- Mostrar el nombre del contratista en la primera fila del grupo -->
            <tr>
            <td [attr.rowspan]="
                (entry[1] | filterBySupplierPayment : (searchTextControl.value || '')).length + 2
              " class="contractor-container">
                <div class="cont-name">{{ entry[0] }}</div>
              </td>
            </tr>
            @for (payment of entry[1] | filterBySupplierPayment : (searchTextControl.value || ''); track payment; let j = $index) {
              <tr>
                <td class="date-td">
                  {{ payment.taskDate | date : "dd/MM/yyyy" }}
                </td>
                <td class="task-td">{{ payment.taskType }}</td>
                <td class="comon-td">{{ payment.productName }}</td>
                <td class="comon-td">{{ payment.clientCity }}</td>
                <td class="comon-td">{{ payment.clientName }}</td>
                <td class="comon-td">{{ payment.additional }}%</td>
                <td class="comon-td">{{ payment.amount }}</td>
                <td class="comon-td">{{ payment.amountWithAdditional }}</td>
                @if (
                  i !== observationsAvailability.rowIndex ||
                  j !== observationsAvailability.paymentIndex
                  ) {
                  <td>
                    <div class="observation-cell">
                      <div class="observation-cell__text">
                        {{ payment.observation }}
                      </div>
                      <app-icon-menu-button [menu]="menu" label="Opciones de la observación"></app-icon-menu-button>
                      <mat-menu #menu>
                        <button mat-menu-item (click)="inputEnable(i, j, payment)">
                          Editar
                        </button>
                        <button mat-menu-item (click)="updateObservation(payment.id, '')">
                          Borrar
                        </button>
                      </mat-menu>
                    </div>
                  </td>
                }
                @if (
                  i === observationsAvailability.rowIndex &&
                  j === observationsAvailability.paymentIndex
                  ) {
                  <td style="max-width: 220px">
                    <div class="observation-cell">
                      <div class="observation-cell__text">
                        <input class="observations" type="text" [(ngModel)]="observations" maxlength="80" aria-label="Observación" />
                      </div>
                      <div class="observation-cell__save" (keydown)="updateObservation(payment.id, observations)"
                        (click)="updateObservation(payment.id, observations)">
                        <mat-icon>task_alt</mat-icon>
                      </div>
                    </div>
                  </td>
                }
              </tr>
            }
            <tr>
              <td colspan="7"></td>
              <td class="totals">
                <strong>{{
                  getTotalsByContractorName(
                  entry[1] | filterBySupplierPayment : (searchTextControl.value || '')
                  )
                }}</strong>
              </td>
              <td colspan="1"></td>
            </tr>
            @if (
              isLastContractorPayment(groupedData, entry, i) &&
              filteredEntriesArray.length > i + 1
              ) {
              <tr class="group-gap">
                <td colspan="8" style="border: none"></td>
              </tr>
            }
          }
        </tbody>
      </table>
      <!-- The empty-state text used to show while the request was still running (and stayed if it failed). -->
      @if (loading) {
        <div class="no-results" aria-busy="true">Cargando pagos…</div>
      } @else if (loadError) {
        <tp-empty-state
          icon="cloud_off"
          title="No se pudieron cargar los pagos"
          message="Probá de nuevo en unos segundos."
        ></tp-empty-state>
      } @else if (filteredEntriesArray.length < 1 && entriesArray.length > 0) {
        <!-- There are payments in the period, the search hides them all. -->
        <tp-empty-state
          icon="search_off"
          title="Sin resultados"
          message="No hay pagos que coincidan con la búsqueda."
        ></tp-empty-state>
      } @else if (filteredEntriesArray.length < 1) {
        <tp-empty-state
          icon="payments"
          title="Sin pagos"
          message="No se encontraron pagos para el período seleccionado"
        ></tp-empty-state>
      }
    </div>
    <div class="scr-footer pager">
      <label class="pager__label" for="paginas">
        Registros por página
        <select id="paginas" (change)="setRegsXPage($event)">
          @for (pagesSelected of regXPage; track pagesSelected) {
            <option [value]="pagesSelected">
              {{ pagesSelected }}
            </option>
          }
        </select>
      </label>
      <div class="pager__nav">
        <span class="scr-count">{{ rangeLabel }}</span>
        <button mat-icon-button type="button" aria-label="Página anterior" [disabled]="pages == 0" (click)="previousPage()">
          <mat-icon>keyboard_arrow_left</mat-icon>
        </button>
        <button mat-icon-button type="button" aria-label="Página siguiente" [disabled]="filteredEntriesArray.length <= pages + seleccionado" (click)="nextPage()">
          <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
      </div>
    </div>
  </div>
</section>
